import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "umbraco-form-page umbraco-forms-page" }

import { PropType } from "vue";
import { IUmbracoFormPage } from "@/models/umbraco-forms/IUmbracoFormPage";


export default /*#__PURE__*/_defineComponent({
  __name: 'UmbracoFormPage',
  props: {
  page: {
    type: Object as PropType<IUmbracoFormPage>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", { page: __props.page })
  ]))
}
}

})